var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.565 9.355c2.43 0 4.355-1.94 4.302-4.333S10.8.688 8.37.688s-4.356 1.94-4.302 4.333c.053 2.393 2.066 4.334 4.496 4.334M15.44 20.966c.664 0 1.207-.512 1.23-1.157l.177-4.432c.064-1.767-1.205-3.386-3.143-3.923-1.251-.347-2.946-.604-5.217-.598-2.268.006-3.96.273-5.208.626-1.937.547-3.193 2.176-3.114 3.944l.204 4.394c.028.64.57 1.146 1.23 1.146z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.241,
    d: "M13 21v-3M4 18v3"
  })));
};
export default SvgPerson;